import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  forwardRef,
  Injector,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import {
  NUMBER_SPINNER_INPUTS,
  NUMBER_SPINNER_VIEW_PROVIDERS,
  NumberSpinnerComponent,
  SpinType,
  ZERO,
} from "shared/base-components/number-spinner.component";
import { BigNumber } from "shared/cubiq-model-multi-asset";
import { BfxFieldNumberDirective } from "../../shared/base-components/bfx-field-number";
import { BfxInputDirective } from "../../shared/base-components/bfx-input";

export const AMOUNT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BfxRateSpinnerComponent),
  multi: true,
};

const TAB = "Tab";

@Component({
  selector: "bfx-rate-spinner",
  templateUrl: "../../shared/base-components/html/number-spinner.html",
  providers: [AMOUNT_VALUE_ACCESSOR],
  viewProviders: NUMBER_SPINNER_VIEW_PROVIDERS,
  inputs: NUMBER_SPINNER_INPUTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BfxRateSpinnerComponent extends NumberSpinnerComponent implements OnChanges {
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Input("proxyTab") public tabForward: Function = null;

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */

  constructor(
    injector: Injector,
    inputDirective: BfxInputDirective,
    fieldDirective: BfxFieldNumberDirective,
    public el: ElementRef,
  ) {
    super(injector, inputDirective, fieldDirective);

    this.maxPrecision = 5;
    this.minPrecision = 2;
    this.spinType = SpinType.PIP;
    this.min = ZERO;
    this.step = new BigNumber("0.01");
    this.spinType = SpinType.CONSTANT;
    this.keyboardMultipliersEnabled = false;
    this.mandatory = false;
    this.groupNonDecimals = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (this._externalState != null) {
      this.state = this._externalState;
    }
  }

  /**********************************************************************/
  /* METHODS */
  public override onKeyDown(event: KeyboardEvent): void {
    if (event.key == TAB && this.tabForward) {
      this.tabForward(event);
    } else {
      super.onKeyDown(event);
    }
  }
}
